export default __webpack_public_path__ + "static/media/hht2_ani_06.4546a3a2.png";